import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaEnvelope } from 'react-icons/fa';
import developerImage from '../assets/developer_workspace.png';

const AboutMe = () => {
  return (
    <section id="about" className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[var(--primary)] rounded-full blur-[120px] opacity-10 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          {/* Image Column */}
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="absolute inset-0 bg-gradient-to-tr from-[var(--primary)] to-[var(--secondary)] rounded-3xl transform rotate-3 opacity-20 blur-lg"></div>
            <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl group">
              <img 
                src={developerImage} 
                alt="Espace de travail Olney Tech" 
                className="w-full h-auto transform group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#030014] via-transparent to-transparent opacity-60"></div>
              <div className="absolute bottom-6 left-6">
                <div className="text-white font-bold text-xl">Anthony V.</div>
                <div className="text-[var(--secondary)] text-sm">Fondateur & Lead Developer</div>
              </div>
            </div>
          </motion.div>

          {/* Text Column */}
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="inline-block mb-4 px-4 py-1 rounded-full border border-[var(--primary)] bg-[rgba(112,0,255,0.1)] text-[var(--primary)] text-sm font-bold tracking-widest uppercase">
              À PROPOS
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold mb-6 font-['Space_Grotesk'] text-white">
              Pas une Agence Anonyme. <br />
              <span className="text-gradient-primary">Votre Partenaire Voisin.</span>
            </h2>
            
            <div className="space-y-6 text-gray-400 text-lg leading-relaxed">
              <p>
                Bonjour ! Je suis Anthony. Contrairement aux grandes agences où vous n'êtes qu'un numéro de dossier, je suis votre interlocuteur unique à <strong className="text-white">Roncq et Phalempin</strong>.
              </p>
              <p>
                J'ai fondé Olney Tech avec une mission simple : apporter l'excellence technique des grandes entreprises (React, Cloud, IA) aux artisans et PME de notre région.
              </p>
              <p>
                Quand vous m'appelez, c'est moi qui décroche. Quand votre site a besoin d'une mise à jour, c'est moi qui code. Cette proximité est votre meilleure garantie de réactivité.
              </p>
            </div>

            <div className="mt-8 flex gap-4">
              <a href="https://github.com/Antho-van" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center text-white hover:bg-[var(--primary)] hover:scale-110 transition-all">
                <FaGithub size={24} />
              </a>
              <a href="mailto:contact@olney.dev" className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center text-white hover:bg-[var(--secondary)] hover:scale-110 transition-all">
                <FaEnvelope size={24} />
              </a>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default AboutMe;
